import React from "react";
import { Grid } from "semantic-ui-react";
import { dispatch } from '@rematch/core';
import ArrangementPane from './ArrangementPane';
import PracticeFlowTree from './PracticeFlowTree';
import CommunityTree from './CommunityTree';
import { withRouter } from 'react-router-dom';
import BreadCrumbsPage from '../../drive/cards/BreadCrumbs'
import LoadingComponent from '../../../../common/LoadingComponent';

class PracticeAndCommunity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}

  }

  componentWillMount() {
    dispatch.app.setRouteParams(this.props.match.params)
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.displaySecondMenu(null);
    dispatch.createPack.showDuplicateIcon(false);
    dispatch.lifeCycle.setIdToCenterPosition(null);
  }

  render() {
    let height = this.props.componentDesignerDimension;
    let treeHeight = (this.props.componentDesignerDimension.windowHeight - this.props.componentDesignerDimension.height) - 140;

    return (this.props.loadingPacks ?
      <LoadingComponent active={this.props.loadingPack} message="Fetching Configurations" />
      :
      <div className="PracticeCommunityPage containerBox overflow-hide" style={{ maxHeight: (height.windowHeight - height.height) - 50 }}>
        <ArrangementPane {...this.props} setPage="Configure" />
        <BreadCrumbsPage {...this.props} />
        <Grid className="PracticeCommunityPageGrid">
          <Grid.Row className="pad_0">
            <Grid.Column width={8} style={{ padding: "0 10px 0 0" }}>
              <div className="pad_10 treeBox" style={{ height: treeHeight, overflow: "auto" }} >
                <PracticeFlowTree
                  name={this.props.practiceLabelName}
                  user={this.props.user}
                  selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                  selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                  setUniqueId={this.props.setUniqueId}
                  showResourecePaneFlag={this.props.showResourecePaneFlag}
                  collapsedResourcePaneIndexTemp={this.props.collapsedResourcePaneIndexTemp}
                />
              </div>
            </Grid.Column>
            <Grid.Column width={8} style={{ padding: "0 0 0 10px" }}>
              <div className="pad_10 treeBox " style={{ height: treeHeight, overflow: "auto" }}>
                <CommunityTree
                  user={this.props.user}
                  selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity}
                  selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                  setUniqueId={this.props.setUniqueId}
                  showResourecePaneFlag={this.props.showResourecePaneFlag}
                  collapsedResourcePaneIndexTemp={this.props.collapsedResourcePaneIndexTemp}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </div>
    );
  }
}
export default withRouter(PracticeAndCommunity);
